import type { RootState } from 'state';
import FetchingStatus from 'constants/statuses/FetchingStatus';

function getFlightDefinitionGroupFetching(state: RootState): boolean {
  const { fetching } = state.flightDefinitionGroups;

  return fetching === FetchingStatus.InProgress;
}

export default getFlightDefinitionGroupFetching;
